import React from 'react';

// ─── Variant → solid dark bg + white text ───────────────────────────────────
const VARIANT_STYLES: Record<BadgeVariant, string> = {
  success:  'bg-green-600  text-white',
  warning:  'bg-yellow-500 text-white',
  danger:   'bg-red-600    text-white',
  info:     'bg-blue-600   text-white',
  purple:   'bg-purple-600 text-white',
  orange:   'bg-orange-500 text-white',
  indigo:   'bg-indigo-600 text-white',
  pink:     'bg-pink-600   text-white',
  default:  'bg-gray-500   text-white',
};

export type BadgeVariant =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'purple'
  | 'orange'
  | 'indigo'
  | 'pink'
  | 'default';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

/** Square solid badge — single source of truth for all status/priority/stage labels */
const Badge: React.FC<BadgeProps> = ({ variant = 'default', children, className = '' }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-sm text-xs font-semibold ${VARIANT_STYLES[variant]} ${className}`}
  >
    {children}
  </span>
);

export default Badge;
